import { basicVideo } from '../../interfaces/basic-video';
import { conditionVideo } from '../../interfaces/condition-video';
import { funcVideo } from '../../interfaces/func-video';
import { loopVideo } from '../../interfaces/loop-video';
import { sequenceVideo } from '../../interfaces/sequence-video';

export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const PATH_AREA = {
    opset: 0,
    x: 30,
    y: 30
};
export const VOICE_SPEED = {
    veryHigh: 1.5,
    high: 1.1,
    normal: 0.8,
    low: 0.6,
    slow: 0.5
};
export const TIME_WAIT_RENDER = 1000;
export const WAIT_CLICK = 300;
export const DRAG_TRIGGER = 7;


export const SCALE = {
    opset: 5,
    scale: {w: 14.25, h: 8},
    player: 2,
    playerScale: {
        w: 1.5,
        h: 2.8
    },
    trafficeScale: {
        w: 4,
        h: 2
    },
    waterScale: {
        w: 1.2,
        h: 1.2
    },
    eyeScale: {
        w: 1.5,
        h: 1.5
    },
    // player_size: { w: 238, h: 400 },
    recycle: {w: 240, h: 216},
    eye: {w: 138, h: 138},
    map_size: {w: 8, h: 8},
    destCandy: {
        w: 2,
        h: 2
    },
    destENV: {
        w: 2,
        h: 2
    },
    destDentistScale: {
        w: 0.2,
        h: 0.2
    },
    destDentist: {
        w: 2,
        h: 2
    },
    destTooth: {
        w: 4,
        h: 2
    }
};
export const PLAYER_PROPERTIES = {
    size: {
        w: 238,
        h: 460
    },
    sizeTraffic: {
        w: 226,
        h: 113
    },
    anchor: {
        w: 0.5,
        h: 0.5
    },
    speed: 1000,
    state: {
        idle: [0, 1, 2, 3, 4, 5, 6, 7],
        run: [8, 9, 10, 11, 12, 13, 14, 15],
        jump: [16, 17, 18, 19, 20, 21, 22, 23],
        idle_left: [24, 25, 26, 27, 28, 29, 30, 31],
        run_left: [32, 33, 34, 35, 36, 37, 38, 39],
        jump_left: [40, 41, 42, 43, 44, 45, 46, 47],
        up: [48, 49, 50, 51, 52, 53, 54, 55],
        down: [56, 57, 58, 59, 60, 61, 62, 63]
    },
    stateDentist: {
        idle: [0],
        brush: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
        run: [0],
        jump: [0],
        idle_left: [0],
        run_left: [0],
        jump_left: [0],
        up: [0],
        down: [0]
    },
    stateFocus: {
        idle: [0],
        brush: [0],
        run: [0],
        jump: [0],
        idle_left: [0],
        run_left: [0],
        jump_left: [0],
        up: [0],
        down: [0]
    },
    stateTraffic: {
        idle: [0],
        run: [0],
        jump: [0],
        idle_left: [1],
        run_left: [1],
        jump_left: [1],
        up: [0],
        down: [0],
        action: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    },
    eyes: {
        idle: [0],
        blind: [0, 1, 2, 3, 4]
    },
    recyle: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]
};
export const MAP_OBJECTS = {
    WALL: 0,
    PATH: 1,
    PLAYER: 3,
    DESTINATE: 4,
    TRAP: 5,

    LEFT: 2,
    RIGHT: 3,
    UP: 4,
    DOWN: 5,
    SCRIPT: 6,
    HIDDEN: 8
};
export const MUSIC = {
    play: '../../../../assets/audio/bgmusic.mp3',
    main: '../../../../assets/audio/jolly_fun.mp3',
    win: '../../../../assets/audio/collect_jigsaw_piece_win.mp3',
    delete: '../../../../assets/audio/delete_block.mp3',
    insertBlock: '../../../../assets/audio/ghep_block.mp3',
    pickCandy: '../../../../assets/audio/pick_candy.mp3',
    pickBlock: '../../../../assets/audio/pick block.mp3',
    select: '../../../../assets/audio/select.mp3',
    selectLevel: '../../../../assets/audio/select level.mp3',
    button: '../../../../assets/audio/button_common.mp3',
    brushTeeth: '../../../../assets/audio/danh_rang.mp3',
    eyes: '../../../../assets/audio/nho-thuoc.mp3'
};
export const GAME_TYPE = {
    basic: {
        name: 'CƠ BẢN',
        routing: 'basic-level',
        type: 'basic',
        map_id: 1,
        translate: 'gameTYPE.basic',
        image: 'may-bay.png',
        icon: 'basic-icon.png',
        video: {
            SWEET: basicVideo.candy,
            ENVIRONMENT: basicVideo.environment,
            DENTIST: basicVideo.dentist,
            TRAFFIC: basicVideo.traffic
        },
        thumbNail: {
            SWEET: 'basic-candy.jpg',
            ENVIRONMENT: 'basic-mt.jpg',
            DENTIST: 'basic-dentist.jpg',
            TRAFFIC: 'basic-traffic.jpg'
        }
    },
    condition: {
        name: 'ĐIỀU KIỆN',
        routing: 'condit-level',
        type: 'condition',
        map_id: 2,
        translate: 'gameTYPE.condition',
        image: 'dia-bay.png',
        icon: 'condition-icon.png',
        video: {
            SWEET: conditionVideo.candy,
            ENVIRONMENT: conditionVideo.environment,
            DENTIST: conditionVideo.dentist,
            TRAFFIC: conditionVideo.traffic
        },
        thumbNail: {
            SWEET: 'condition-candy.jpg',
            ENVIRONMENT: 'condition-mt.jpg',
            DENTIST: 'condition-dentist.jpg',
            TRAFFIC: 'cond-traffic.jpg'
        }
    },
    func: {
        name: 'HÀM',
        routing: 'func-level',
        type: 'func',
        map_id: 3,
        translate: 'gameTYPE.function',
        image: 'ten-lua.png',
        icon: 'func-icon.png',
        video: {
            SWEET: funcVideo.candy,
            ENVIRONMENT: funcVideo.environment,
            DENTIST: funcVideo.dentist,
            TRAFFIC: funcVideo.traffic
        },
        thumbNail: {
            SWEET: 'func-candy.jpg',
            ENVIRONMENT: 'func-mt.jpg',
            DENTIST: 'func-dent.jpg',
            TRAFFIC: 'func-traffic.jpg'
        }
    },
    loop: {
        name: 'VÒNG LẶP',
        routing: 'loop-level',
        type: 'loop',
        map_id: 4,
        translate: 'gameTYPE.loop',
        image: 'cuu-hoa.png',
        icon: 'loop-icon.png',
        video: {
            SWEET: loopVideo.candy,
            ENVIRONMENT: loopVideo.environment,
            DENTIST: loopVideo.dentist,
            TRAFFIC: loopVideo.traffic
        },
        thumbNail: {
            SWEET: 'loop-candy.jpg',
            ENVIRONMENT: 'loop-mt.jpg',
            DENTIST: 'loop-dent.jpg',
            TRAFFIC: 'loop-traffic.jpg'
        }
    },
    sequence: {
        name: 'TUẦN TỰ',
        routing: 'sequence-level',
        type: 'sequence',
        map_id: 5,
        translate: 'gameTYPE.sequence',
        image: 'policecar2.png',
        icon: 'sequence-icon.png',
        video: {
            SWEET: sequenceVideo.candy,
            ENVIRONMENT: sequenceVideo.environment,
            DENTIST: sequenceVideo.dentist,
            TRAFFIC: sequenceVideo.traffic
        },
        thumbNail: {
            SWEET: 'sequence-candy.jpg',
            ENVIRONMENT: 'sequence-mt.jpg',
            DENTIST: 'sequence-dent.jpg',
            TRAFFIC: 'sequence-traffic.jpg'
        }
    }
};
export const GAME_TOPIC = [
    {
        name: 'SWEET',
        TYPE: 'BÁNH KẸO',
        picCar: '../../assets/images/policecar2.png',
        picBottomCard: '../../assets/images/basic@3x.png',
        translate: 'gameTopic.SWEET'
    },
    {
        name: 'ENVIRONMENT',
        TYPE: 'MÔI TRƯỜNG',
        picCar: '../../assets/images/policecar2.png',
        picBottomCard: '../../assets/images/basic@3x.png',
        translate: 'gameTopic.ENVIRONMENT'
    },
    {
        name: 'DENTIST',
        TYPE: 'NHA SĨ',
        picCar: '../../assets/images/policecar2.png',
        picBottomCard: '../../assets/images/basic@3x.png',
        translate: 'gameTopic.DENTIST'
    },
    {
        name: 'TRAFFIC',
        TYPE: 'GIAO THÔNG',
        picCar: '../../assets/images/policecar2.png',
        picBottomCard: '../../assets/images/basic@3x.png',
        translate: 'gameTopic.TRAFFIC'
    }
];

export const ENV_DEST = {
    water: {
        animation: 'water',
        run: [0, 1, 2, 3, 4, 5, 6, 7],
        sound: '../../../../assets/audio/tuoi_nuoc.mp3'
    },
    flower: {
        animation: 'flower-grow',
        run: [0, 1, 2, 3, 4],
        sound: '../../../../assets/audio/grow.mp3'
    },
    feed: {
        animation: 'bon_phan',
        run: [0, 1, 2, 3, 4, 5, 6, 7],
        sound: '../../../../assets/audio/bon_phan.mp3'
    },
    treeGrow: {
        animation: 'tree_grow',
        run: [0, 1, 2, 3, 4, 5, 6, 7],
        sound: '../../../../assets/audio/grow.mp3'
    },
    treeFruit: {
        animation: 'ra_qua',
        run: [0, 1, 2, 3, 4, 5, 6, 7],
        sound: '../../../../assets/audio/grow.mp3'
    },
    seedGrow: {
        animation: 'troi_non',
        run: [0, 1, 2, 3, 4, 5],
        sound: '../../../../assets/audio/grow.mp3'
    },
    killWorm: {
        animation: 'xit thuoc',
        run: [0, 1, 2, 3, 4, 5, 6, 7],
        sound: '../../../../assets/audio/thuoc_sau.mp3'
    },
    treeWorm: {
        animation: 'cay_sau',
        run: [0, 1, 2, 3, 4, 5],
        sound: ''
    },
    bagFruit: {
        animation: 'gio_tao',
        run: [0, 1, 2, 3, 4, 5],
        sound: '../../../../assets/audio/cat_qua.mp3'
    },
    brushTeeth: {
        animation: 'danh_rang',
        run: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
        sound: '../../../../assets/audio/danh_rang.mp3'
    },
    toothDrop: {
        animation: 'nho-thuoc',
        run: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        sound: '../../../../assets/audio/nho-thuoc.mp3'
    },
    concrete: {
        animation: 'do-be-tong',
        run: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        sound: '../../../../assets/audio/tron-be-tong.mp3'
    },
    excavator: {
        animation: 'may-xuc',
        run: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        sound: '../../../../assets/audio/may-xuc.mp3'
    },
    roller: {
        animation: 'xe-lu',
        run: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        sound: '../../../../assets/audio/xe-lu.mp3'
    },
    crane: {
        animation: 'can-cau',
        run: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        sound: '../../../../assets/audio/can-cau.mp3'
    },
    greenLight: {
        animation: 'den-xanh',
        run: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        sound: '../../../../assets/audio/den-xanh.mp3'
    },
    redLight: {
        animation: 'den-do',
        run: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        sound: '../../../../assets/audio/den-do.mp3'
    },
    scale: {
        w: 1,
        h: 1
    },
    size: {
        w: 113,
        h: 113
    },
    tooth: {
        w: 238,
        h: 113
    },
    recycle: '../../../../assets/common/sprites/do_rac.png'
};
export const EYES_BLINK = 5000;
export const MAX_LEVEL = 20;
export const MAX_LEVEL_UNLOCK = 5;

